import { FC } from 'react';
import { Controller, useFormContext } from 'react-hook-form';

import formatPercent from 'common/formatPercent';
import * as Form from 'components/_core/form';
import SunshineDropdown from 'components/_core/SunshineDropdown';

import { FormSchema } from '../../../../form';

interface VatRateInputProps {
  index: number;
  label: string;
  computeVatAmountFromRate: (rate: number) => number;
}

const VAT_RATES = [0, 2.1, 5.5, 10, 20];

const VatRateInput: FC<VatRateInputProps> = ({
  computeVatAmountFromRate,
  index,
  label,
}) => {
  const { control, setValue } = useFormContext<FormSchema>();

  return (
    <Controller
      control={control}
      name={`rows.${index}.trueVatRate`}
      render={({ field: { onChange, value }, formState: { errors } }) => (
        <Form.Field
          error={errors.rows?.[index]?.trueVatRate?.message}
          label={label}
        >
          <SunshineDropdown autoSelect={false} closeOnBlur>
            <SunshineDropdown.Trigger>
              <Form.Input
                onChange={onChange}
                type="number"
                value={value ?? ''}
              />
            </SunshineDropdown.Trigger>

            <SunshineDropdown.List>
              {VAT_RATES.map((rate) => (
                <SunshineDropdown.Item
                  key={rate}
                  onClick={() => {
                    setValue(
                      `rows.${index}.trueVatAmount`,
                      computeVatAmountFromRate(rate),
                    );

                    onChange(rate);
                  }}
                >
                  {formatPercent(rate / 100)}
                </SunshineDropdown.Item>
              ))}
            </SunshineDropdown.List>
          </SunshineDropdown>
        </Form.Field>
      )}
    />
  );
};

export default VatRateInput;
